import React, { useEffect, useState } from "react";
import RateCanvas from "../RateCanvas";
import { Link } from "react-router-dom"; // Для навигации, если используете react-router
import { useLocation } from "react-router-dom";
import Api from "../Api";
import { BASE_API_URL } from "../const";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  TextField,
  Checkbox,
  Button,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

const FilmData = () => {
  const [responseAPI, setResponseAPI] = useState(null);
  const [filmId, setFilmId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [sendData, setSendData] = useState({});

  const location = useLocation();

  const href = `/dev.api.mbase2.idc.md/api/image/${filmId}`;

  useEffect(() => {
    if (filmId) getDataFilmWithID();
  }, []);

  useEffect(() => {
    const url = window.location.href;
    const pathname = new URL(url).pathname;
    const id = pathname.split("/").pop();

    if (id) {
      setFilmId(id);
    }
  }, [location]);

  useEffect(() => {
    if (filmId !== null) {
      getDataFilmWithID(filmId);
    }
  }, [filmId]);

  async function getDataFilmWithID(id) {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/movie/${id}`);
      setResponseAPI(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }

  const flattenData = (data) => {
    const result = [];

    const processObject = (obj, parentKey = "") => {
      for (let key in obj) {
        const fullKey = parentKey ? `${parentKey}.${key}` : key;
        if (Array.isArray(obj[key])) {
          result.push({ key: fullKey, value: obj[key].join(", ") });
        } else if (typeof obj[key] === "object" && obj[key] !== null) {
          processObject(obj[key], fullKey);
        } else {
          result.push({ key: fullKey, value: obj[key] });
        }
      }
    };

    processObject(data);
    return result;
  };
    const handleInputChange = (key, value) => {
      setSendData((prevData) => ({
        ...prevData,
        [key]: value,
      }));
  };
    const handleSendData = () => {
      console.log("Отправка данных:", sendData);
      // Здесь можно отправить `sendData` на сервер
    };

  let tableData = null;
  let rates;

  if (responseAPI) {
    tableData = flattenData(responseAPI);
    rates = {
      voteKP: responseAPI.rate.voteKP,
      voteIMDB: responseAPI.rate.voteIMDB,
      rateKP: responseAPI.rate.rateKP,
      rateIMDB: responseAPI.rate.rateIMDB,
    };
  }
  //-----

  return (
    <Box sx={{ padding: 2 }}>
      {/* Заголовок с голубым фоном и закругленными углами */}
      <Paper
        sx={{
          backgroundColor: "#E0F7FA", // Светло-голубой цвет
          padding: 2,
          borderRadius: 2,
          marginBottom: 2, // Отступ снизу
          display: "flex", // Для выравнивания иконки и заголовка в одну линию
          alignItems: "center",
        }}
      >
        {/* Иконка "домой" с ссылкой */}
        <Link to="/" style={{ textDecoration: "none" }}>
          <IconButton>
            <HomeIcon sx={{ color: "#00796B" }} /> {/* Цвет иконки */}
          </IconButton>
        </Link>

        {/* Заголовок по центру */}
        <Typography
          variant="h5"
          align="center"
          color="primary"
          sx={{ flexGrow: 1 }}
        >
          {/* {responseAPI && responseAPI.title} */}
          Заголовок
        </Typography>
      </Paper>

      {/* Контейнер для трёх колонок */}
      <Box sx={{ display: "flex", gap: 2 }}>
        {/* Первая колонка - 25%, с изображением по центру */}
        <Box
          sx={{
            flex: "0 0 25%", // Ширина 25%
            backgroundColor: "#F5F5F5", // Серый фон для примера
            padding: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start", // Центрирование по горизонтали
            alignItems: "center", // Центрирование по вертикали
            borderRadius: 1,
          }}
        >
          {responseAPI && responseAPI.options.poster_source_S ? (
            <img
              src={responseAPI.options.poster_source_S}
              alt="Постер фильма"
              width="280"
              height="420"
              style={{ borderRadius: "8px" }}
            />
          ) : (
            <Typography>Загрузка изображения...</Typography>
          )}
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              marginTop: 2,
              overflow: "auto",
              height: "300px",
            }}
          ></TableContainer>
        </Box>

        {/* Центральная колонка - 50%, таблица с объектом "data" */}
        <Box
          sx={{
            flex: "0 0 50%", // Ширина 50%
            backgroundColor: "#E8EAF6", // Голубой фон для примера
            padding: 2,
            borderRadius: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 2,
            }}
          >
            {/* Заголовок "Информация о фильме" по центру */}
            <Typography variant="h6" align="center" sx={{ flexGrow: 1 }}>
              Информация о фильме
            </Typography>

            {/* Чекбокс и текст "Редактировать" в правом углу */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                checked={editMode}
                onChange={(e) => setEditMode(e.target.checked)}
              />
              <Typography>Редактировать</Typography>
            </Box>
          </Box>

          {responseAPI ? (
            <TableContainer>
              <Table>
                <TableBody>
                  {tableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.key}</TableCell>
                      <TableCell>
                        {editMode ? (
                          <TextField
                            fullWidth
                            value={sendData[row.key] || row.value || ""}
                            onChange={(e) =>
                              handleInputChange(row.key, e.target.value)
                            }
                          />
                        ) : (
                          row.value
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell>
                      <Typography>
                        Рейтинги фильма - сгенерированный JPEG
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 32, // Отступ между картинкой и кнопкой
                          marginTop: 2,
                        }}
                      >
                        {/* Картинка */}
                        <a
                          href={href}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <RateCanvas rates={responseAPI} />
                        </a>

                        {/* Кнопка справа от картинки */}
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSendData}
                          disabled={!editMode}
                        >
                          Отправить
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography>Загрузка данных...</Typography>
          )}
        </Box>

        {/* Правая колонка - 25% */}
      </Box>
    </Box>
  );
};

export default FilmData;
